import { useSelector } from "react-redux";
import Families from "../../../components/DataCollection/Families/Families";
import Page404 from "../../../components/Page404/Page403";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../features/userSlice";

const FamiliesScreen = () => {
  const userData = useSelector(selectUserData);
  const hasFamiliesScreenPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    "businesse_advisor",
    "view_families",
  );

  return <>{!hasFamiliesScreenPermission ? <Page404 /> : <Families />}</>;
};

export default FamiliesScreen;
